import React, { useState, useEffect, useMemo } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";
import RightsCheck from "../General/RightsCheck";

const PrintReceiptPayment = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [loading, setLoading] = useState(false);
  const [listOpening, setListOpening] = useState([]);
  const [listReceipts, setListReceipts] = useState([]);
  const [listPayments, setListPayments] = useState([]);
  const [listClosing, setListClosing] = useState([]);

  const [openingDebitTotal, setOpeningDebitTotal] = useState("");
  const [openingCreditTotal, setOpeningCreditTotal] = useState("");
  const [receiptsDebitTotal, setReceiptsDebitTotal] = useState("");
  const [receiptsCreditTotal, setReceiptsCreditTotal] = useState("");
  const [paymentsDebitTotal, setPaymentsDebitTotal] = useState("");
  const [paymentsCreditTotal, setPaymentsCreditTotal] = useState("");
  const [closingDebitTotal, setClosingDebitTotal] = useState("");
  const [closingCreditTotal, setClosingCreditTotal] = useState("");

  const filters = useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const fyear =
      urlParams.get("fyear") || localStorage.getItem("DefaultFYear") || "";
    return {
      fyear,
      startDate: urlParams.get("startDate") || (fyear ? `${fyear}-04-01` : ""),
      endDate: urlParams.get("endDate") || "",
      accountLevel:
        urlParams.get("accountLevel") ||
        urlParams.get("Accountlevel") ||
        "0",
      showZeroAccounts: urlParams.get("showZeroAccounts") !== "0",
      showThirdOnly: urlParams.get("showThirdOnly") !== "0",
      accountCode: (
        urlParams.get("accountCode") ||
        urlParams.get("AccountCode") ||
        ""
      ).trim(),
      accountName: (
        urlParams.get("accountName") ||
        urlParams.get("AccountName") ||
        ""
      ).trim(),
    };
  }, []);

  useEffect(() => {
    document.title = "Print Receipt Payment Account";
    const year = parseInt(filters.fyear, 10);
    if (!year || !filters.endDate) {
      return;
    }

    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "Accounts/GetReceiptPayment",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        pageNo: 1,
        pageSize: 10000,
        FYear: year,
        StartDate: filters.startDate,
        EndDate: filters.endDate,
        AccountLevel: parseInt(filters.accountLevel, 10) || 0,
        ShowZeroAccounts: filters.showZeroAccounts,
        ShowThirdOnly: filters.showThirdOnly,
        AccountCode: filters.accountCode,
        AccountName: filters.accountName,
      },
    })
      .then((response) => {
        if (response.data?.status_code === 1) {
          setListOpening(response.data?.ListofOpening ?? []);
          setListReceipts(response.data?.ListofReceipts ?? []);
          setListPayments(response.data?.ListofPayments ?? []);
          setListClosing(response.data?.ListofClosing ?? []);
          setOpeningDebitTotal(response.data?.OpeningDebitTotal ?? "");
          setOpeningCreditTotal(response.data?.OpeningCreditTotal ?? "");
          setReceiptsDebitTotal(response.data?.ReceiptsDebitTotal ?? "");
          setReceiptsCreditTotal(response.data?.ReceiptsCreditTotal ?? "");
          setPaymentsDebitTotal(response.data?.PaymentsDebitTotal ?? "");
          setPaymentsCreditTotal(response.data?.PaymentsCreditTotal ?? "");
          setClosingDebitTotal(response.data?.ClosingDebitTotal ?? "");
          setClosingCreditTotal(response.data?.ClosingCreditTotal ?? "");
        } else {
          setListOpening([]);
          setListReceipts([]);
          setListPayments([]);
          setListClosing([]);
        }
      })
      .catch(() => {
        setListOpening([]);
        setListReceipts([]);
        setListPayments([]);
        setListClosing([]);
      })
      .finally(() => setLoading(false));
  }, [AccessKey, UserID, MemberType, filters]);

  const levelLabel =
    filters.accountLevel === "1"
      ? "1st Level"
      : filters.accountLevel === "2"
      ? "2nd Level"
      : filters.accountLevel === "3"
      ? "3rd Level"
      : "All Levels";

  const renderSectionBody = (rows, debitTotal, creditTotal) => {
    if (loading) {
      return (
        <tr>
          <td colSpan={5} className="text-center">
            <Spinner animation="border" role="status" />
          </td>
        </tr>
      );
    }
    if (rows?.length > 0) {
      return (
        <>
          {rows.map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{item.Selected_Account?.Account_Code}</td>
              <td>{item.Selected_Account?.Account_Description}</td>
              <td className="text-end">{item.ClosingDebit}</td>
              <td className="text-end">{item.ClosingCredit}</td>
            </tr>
          ))}
          <tr>
            <td colSpan={3} className="text-end fw-bold">
              Total
            </td>
            <td className="text-end fw-bold">{debitTotal}</td>
            <td className="text-end fw-bold">{creditTotal}</td>
          </tr>
        </>
      );
    }
    return (
      <tr>
        <td colSpan={5} className="text-center text-muted">
          No Data Found
        </td>
      </tr>
    );
  };

  const sectionHeader = (title) => (
  <>
    <tr>
      <th colSpan={5}>{title}</th>
    </tr>
    <tr>
      <th>Sr.</th>
      <th>Account Code</th>
      <th>Account Name</th>
      <th className="text-end">Debit</th>
      <th className="text-end">Credit</th>
    </tr>
  </>
  );

  return (
    <>
      <RightsCheck />
      <Page orientation="landscape" size="a4">
        <table className="table table-sm table-bordered table-print">
          <thead>
            <tr>
              <th colSpan={5}>
                <PrintHeader title="Receipt Payment Account" />
              </th>
            </tr>
            <tr>
              <th colSpan={5}>
                Year: {filters.fyear} | Level: {levelLabel} | From:{" "}
                {filters.startDate || "—"} | To: {filters.endDate || "—"} |
                Zero rows: {filters.showZeroAccounts ? "Yes" : "No"} |
                3rd level only: {filters.showThirdOnly ? "Yes" : "No"}
              </th>
            </tr>
          </thead>
          <tbody>
            {sectionHeader("Opening Balance (Cash & Bank)")}
            {renderSectionBody(
              listOpening,
              openingDebitTotal,
              openingCreditTotal
            )}
            {sectionHeader("Receipts (Income)")}
            {renderSectionBody(
              listReceipts,
              receiptsDebitTotal,
              receiptsCreditTotal
            )}
            {sectionHeader("Payments (Expenditure)")}
            {renderSectionBody(
              listPayments,
              paymentsDebitTotal,
              paymentsCreditTotal
            )}
            {sectionHeader("Closing Balance (Cash & Bank)")}
            {renderSectionBody(
              listClosing,
              closingDebitTotal,
              closingCreditTotal
            )}
          </tbody>
        </table>
      </Page>
    </>
  );
};

export default PrintReceiptPayment;
